import { Button } from '@mui/material'

import { Icon } from '@/components'
import { downloadGeneratedFile } from '@/utils'

export const DownloadSampleCSV = () => {
  const onHandleClick = () => {
    downloadGeneratedFile(
      'semantic-search-sample.csv',
      `key,question,answerText,source,suggestedquestions
1,This is the question text,This is the question answer,Generated by Vail,0`
    )
  }
  return (
    <Button
      startIcon={<Icon name="download" />}
      sx={{ alignSelf: 'flex-end' }}
      variant="text"
      onClick={onHandleClick}
    >
      Download sample CSV
    </Button>
  )
}
